import type { SubNavRoute } from '@/constants/routes';
import {
  COMPANY_SUMMARY_ANCHOR,
  COMPANY_VALUE_ANCHOR,
  COMPANY_FUTURE_ANCHOR,
  COMPANY_PAST_ANCHOR,
  COMPANY_HEALTH_ANCHOR,
  COMPANY_DIVIDEND_ANCHOR,
  COMPANY_MANAGEMENT_ANCHOR,
  COMPANY_OWNERSHIP_ANCHOR,
  COMPANY_INFORMATION_ANCHOR,
} from '@/constants/anchors';
import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

const HideLgDown = styled('span')`
  ${media.lgDown`
		display: none;
	`};
`;

export const routes: SubNavRoute[] = [
  {
    anchor: COMPANY_SUMMARY_ANCHOR,
    tracking: 'Executive Summary',
    label: (
      <>
        <HideLgDown>Company</HideLgDown> Overview
      </>
    ),
  },
  { anchor: COMPANY_VALUE_ANCHOR, label: 'Valuation' },
  {
    anchor: COMPANY_FUTURE_ANCHOR,
    tracking: 'Future Growth',
    label: (
      <>
        Future <HideLgDown>Growth</HideLgDown>
      </>
    ),
  },
  {
    anchor: COMPANY_PAST_ANCHOR,
    tracking: 'Past Performance',
    label: (
      <>
        Past <HideLgDown>Performance</HideLgDown>
      </>
    ),
  },
  {
    anchor: COMPANY_HEALTH_ANCHOR,
    tracking: 'Financial Health',
    label: (
      <>
        <HideLgDown>Financial </HideLgDown>Health
      </>
    ),
  },
  { anchor: COMPANY_DIVIDEND_ANCHOR, label: 'Dividend' },
  { anchor: COMPANY_MANAGEMENT_ANCHOR, label: 'Management' },
  { anchor: COMPANY_OWNERSHIP_ANCHOR, label: 'Ownership' },
  {
    anchor: COMPANY_INFORMATION_ANCHOR,
    tracking: 'Company Information',
    label: (
      <>
        <HideLgDown>Other</HideLgDown> Information
      </>
    ),
  },
];
